"use client";

import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const industries = [{
  title: "Corporate",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_corporate.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/20240119_153354561_iOS-scaled-e1773955954799.jpg)] absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/Corporate.jpg)] absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/Corporate1.jpg)]"
}, {
  title: "Higher Education",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_higher_education.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/New-Project-1.jpg)]"
}, {
  title: "Healthcare",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_healthcare.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/specialized_healthcare-e1773955382280.webp)] absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/specialized_healthcare-e1773955382280.webp)] absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://www.wt-solutions.com/wp-content/uploads/2026/03/healthcare_environments.webp)] absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://www.wt-solutions.com/wp-content/uploads/2026/04/New-Project-2.jpg)]"
}, {
  title: "Government",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_government.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://www.wt-solutions.com/wp-content/uploads/2026/04/GOV.jpg)]"
}, {
  title: "House of Worship",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_house_of_worship.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/Church.jpg)]"
}, {
  title: "Hospitality",
  link: "/SolutionsPage",
  sizeClass: "basis-full md:basis-1/2 lg:basis-1/3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/industry_hospitality.png",
  titleClassName: "absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px] !bg-[url(https://www.wt-solutions.com/wp-content/uploads/2026/04/hospitality.jpg)]"
}];
export default function IndustrySolutionsGallery() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="industry-solutions-gallery" className="dark bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
      backgroundSize: "100px 100px"
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-sm font-mono tracking-widest uppercase mb-4 !text-[hsl(0,95%,41%)]">
            Precision Integration
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
            Engineered for Every Environment
          </h3>
          <p className="text-lg text-muted-foreground">
            From mission-critical government facilities to immersive hospitality venues, 
            we deliver fully integrated, custom audiovisual systems tailored to the unique 
            demands of your space.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="relative w-full">
          <CarouselContent className="-ml-4 md:-ml-6">
            {industries.map((industry, i) => <CarouselItem key={i} data-index={i} className={`pl-4 md:pl-6 ${industry.sizeClass}`}>
                <div className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden rounded-xl group border border-border/50 bg-card">
                  {}
                  <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 bg-[url(${industry.image})]`} aria-hidden="true" />
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500" />
                  
                  {}
                  <div className={`${industry.titleClassName || ""} absolute inset-0 p-8 flex flex-col justify-end z-20 !w-[483px]`}>
                    <div className="transform translate-y-8 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                      <h4 className="text-2xl font-bold text-foreground mb-4 !shadow-[0px_36px_72px_rgba(20,21,31,0.5),_0px_18px_36px_rgba(20,21,31,0.30)] !bg-[rgba(80,78,78,0.5490196078431373)] md:text-3xl">
                        {industry.title}
                      </h4>
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                        <Link to={industry.link}>
                          <Button variant="default" className="group/btn">
                            View Expertise
                            <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex justify-end gap-4 mt-8">
            <CarouselPrevious className="static translate-y-0" />
            <CarouselNext className="static translate-y-0" />
          </div>
        </Carousel>
      </div>
    </section>;
}